<!--
 * @Author: zhangwk
 * @Date: 2022-09-07 8:56:28
 * @LastEditors: zhangwk
 * @LastEditTime: 2022-09-07 8:56:28
 * @describe: 生资商城详情面
-->
<template>
    <el-main class="main-parent" id="apps">
        <div style="position: fixed; top: 0; z-index: 9999;height:129px;width: 100vw;"></div>
        <div class="top-wrap">
            <Bread></Bread>
        </div>
        <div class="main">

            <div class=" wrap-box">
                <div class="commidityWrap container clearfix">
                    <div class="commidityBoxl commidityBoxl1 fl clearfix">
                        <swiperComponents :imgList="imgList" :image="image" v-if="imgList.length > 0">
                        </swiperComponents>
                    </div>

                    <div class="commidityBoxr1 fl clearfix">
                        <p class="font20">{{msg.productsName}}</p>
                        <div class="agrAddress">
                            {{msg.salePoint}}
                        </div>
                        <div class="clearfix marginTop25" v-for="(item , index) in skuList1" v-if="skuList1.length> 0">
                            <span class="fl font66">{{item.title}}</span>
                            <div class="checked-list-box fl clearfix">
                                <p v-for="(val ,keys) in item.value" class="fl"
                                    :class="active1 == keys ? 'active1' : ''">
                                    <img :src="val.titleImageUrl" v-if="val.titleImageUrl"
                                        style="width:38px; height:38px" />
                                    {{val.valueName}}
                                </p>
                            </div>

                        </div>
                        <div class="clearfix marginTop25" v-for="(item , index) in skuList2" v-if="skuList2.length> 0">
                            <span class="fl font66">{{item.title}}</span>
                            <div class="checked-list-box fl clearfix">
                                <p v-for="(val ,keys) in item.list" class="fl" :class="active2 == keys ? 'active2' : ''"
                                    @click="checkedHandle(2,val,keys)">
                                    <img :src="val.imgUrl" v-if="val.imgUrl" style="width:38px; height:38px" />
                                    {{val.specsValue}}
                                </p>
                            </div>

                        </div>
                        <div class="clearfix marginTop25" v-for="(item , index) in skuList3" v-if="skuList3.length> 0">
                            <span class="fl font66">{{item.title}}</span>
                            <div class="checked-list-box fl clearfix">
                                <p v-for="(val ,keys) in item.list" class="fl" :class="active3 == keys ? 'active2' : ''"
                                    @click="checkedHandle(3,val,keys)">
                                    <img :src="val.imgUrl" v-if="val.imgUrl" style="width:38px; height:38px" />
                                    {{val.specsValue}}
                                </p>
                            </div>

                        </div>
                        <div class="clearfix marginTop25">
                            <span class="fl font66">销售价</span>
                            <div class="checked-list-box fl clearfix moneySpan" style="margin-left: 10px;">
                                <strong> <i>¥</i>{{productsPrice2 ? productsPrice2 : msg.productsPrice}}</strong>
                                <i class="itext" v-if="msg.markingPrice">¥{{msg.markingPrice}}</i>
                            </div>
                        </div>
                        <div class="clearfix marginTop25">
                            <span class="fl font66 ">数&nbsp;&nbsp;&nbsp;量</span>
                            <div class="fl numDiv">
                                <el-input-number v-model="num" :min="1" label="描述文字"></el-input-number>
                            </div>
                        </div>
                        <div class="clearfix marginTop25">
                            <span class="fl font66 " v-if="msg.modeOfSupply">
                                供货方式：{{msg.modeOfSupply == 10 ? '现货' : '非现货'}}
                                <template v-if="msg.modeOfSupply == 20 && msg.modeOfDay">
                                    ( {{'供货期'+msg.modeOfDay +'天'}})
                                </template>

                            </span>

                        </div>
                        <!-- <div class="agrBottom marginTop25">
                            <button class="immediatePurchase" @click="callHandle">
                                <img src="@/assets/szoperative/consult_icon.png" alt="">
                                电话咨询
                            </button>
                            <button class="immediatePurchase">立即下单</button>
                        </div> -->

                    </div>

                    <div class="fl commidityBoxRight">
                        <div class="shopBox">
                            <div class="companyName">供应商</div>
                            <img :src="enterpriseInfo.logo" height="80" width="170" alt="" class="companyImg">
                            <div class="realName1" v-if="enterpriseInfo.enterpriseName">
                                {{enterpriseInfo.enterpriseName}}</div>
                            <div class="commidityArea1">{{enterpriseInfo.scopes}}</div>
                            <p class="dre">发货地址</p>
                            <strong class="strong-text realName1">{{enterpriseInfo.addr}}</strong>
                        </div>
                    </div>
                </div>
                <!-- <div class="back-fixed"></div> -->
                <div class="commidityAndShop clearfix">
                    <div class="goodsBox fl">
                        <div class="commonTitle">
                            <h1>商品详情</h1>
                        </div>
                        <div v-show="flag!=1">
                            <div class="commidityTable" v-if="paramList.length > 0">
                                <p v-for="(item , index) in paramList">{{item.parmKey}}：{{item.parmValue}}</p>
                            </div>
                        </div>
                        <div v-show="flag==1">
                            <div class="commidityTable" v-if="paramList.length > 0">
                                <p v-for="(item , index) in paramList">{{item.paramName}}：{{item.paramValue}}</p>
                            </div>
                        </div>
                        <div class="resDataBox" v-html="msg.productDesc"></div>
                    </div>
                </div>
            </div>

        </div>
    </el-main>
</template>
<script>
import "@/styles/szStyle.css"
import swiperComponents from "./swiper";
export default {
    components: {
        swiperComponents,
    },
    name: "ShopVewDetail",
    data() {
        return {
            productsPrice2: null,
            skuList1: [],
            skuList2: [],
            skuList3: [],
            active0: 0,
            active1: 0,
            msg: {},
            paramList: [],
            skuList: [],
            list1: [{
                name: "300ml"
            }, {
                name: "500ml"
            }, {
                name: "800ml"
            }],
            active2: 0,
            active3: 0,
            list2: [{
                name: "无毒"
            }, {
                name: "微毒"
            }, {
                name: "中毒"
            }],
            num: 1,
            imgList: [],
            enterpriseInfo: {},
            ids: "",
            ids1: "",
            ids2: "",
            ids3: "",
            skuName: "",
            specsValue1: '',
            specsValue2: "",
            specsValue3: "",
            imageList: [],
            image: '',
            flag: 2
        };
    },
    mounted() {
        this.getShopDetail();
    },
    methods: {
        getPriceData() {
            //alert(this.ids)
            var params = {
                skuIds: this.ids.toString()
            }
            // this.$http.orders.getPrice(params).then((res) => {
            //     // alert(2)
            //     console.log("res", res)
            //     if (res.data) {

            //         this.productsPrice2 = res.data.productsPrice;
            //     } else {
            //         this.productsPrice2 = null;
            //     }


            // });
        },
        //获取商品类表接口
        getShopDetail() {
            let list = window.localStorage.getItem('obj')
            let data = window.localStorage.getItem('supper')
            console.log(JSON.parse(list));
            console.log(JSON.parse(data));
            console.log(JSON.parse(list).mainSpuVideoUrl);
            this.imgList = JSON.parse(list).ordinarySpuImageUrl.split(',')
            if (JSON.parse(list).parmJson.includes('paramName')) {
                this.flag = 1
            }
            // this.imgList.push(JSON.parse(list).mainSpuVideoUrl)
            if (JSON.parse(list).mainSpuVideoUrl) {
                if (this.imgList.length == 0) {
                    // this.imgList.splice(0,0,JSON.parse(list).mainSpuVideoUrl)
                    this.imgList.push(JSON.parse(list).mainSpuVideoUrl)
                } else {
                    this.imgList.splice(1, 0, JSON.parse(list).mainSpuVideoUrl)
                }
            }

            console.log(this.imgList);
            this.image = JSON.parse(list).mainSpuVideoCoverUrl
            this.msg = JSON.parse(list)
            this.enterpriseInfo = JSON.parse(data)
            this.paramList = JSON.parse(this.msg.parmJson)
            this.skuList1 = JSON.parse(this.msg.specJson)
            // var params = {
            //     id: this.$route.query.id
            // }

            // this.$http.szOrder.getInfo(params).then((res) => {
            //     console.log("商品详情", res)
            //     if (res.data) {
            //         this.msg = res.data;
            //         this.skuList = res.data.skuList;
            //         this.imageList = res.data.imgList
            //         if (this.skuList[0]) {
            //             this.skuList1.push(this.skuList[0])
            //             this.ids1 = this.skuList1[0].list[0].skuId;
            //             this.specsValue1 = this.skuList1[0].list[0].specsValue;
            //             console.log(this.skuList1)
            //         }
            //         if (this.skuList[1]) {
            //             this.skuList2.push(this.skuList[1])
            //             this.ids2 = this.skuList2[0].list[0].skuId;
            //             this.specsValue2 = this.skuList2[0].list[0].specsValue;
            //         }
            //         if (this.skuList[2]) {
            //             this.skuList3.push(this.skuList[2])
            //             this.ids3 = this.skuList3[0].list[0].skuId;
            //             this.specsValue3 = this.skuList3[0].list[0].specsValue;
            //         }
            //         if (this.ids1) {
            //             this.ids = this.ids1;
            //         }
            //         if (this.ids2) {

            //             this.ids = this.ids1 + ',' + this.ids2;
            //         }
            //         if (this.ids3) {
            //             this.ids = this.ids1 + ',' + this.ids2 + ',' + this.ids3;
            //         }

            //         this.skuName = this.specsValue1 + '' + this.specsValue2 + '' + this.specsValue3;
            //         if (this.ids) {
            //             // this.getPriceData();
            //         }

            //         if (res.data.enterpriseInfo) {
            //             this.enterpriseInfo = res.data.enterpriseInfo;
            //         } else {
            //             this.enterpriseInfo = {
            //                 enterprise_name: "",
            //                 scopes: "",
            //                 addr: "",
            //             }
            //         }

            //         this.paramList = res.data.paramList;
            //         this.imgList = res.data.imgList;
            //         this.paramList.sort(function (a, b) {
            //             return a.sort - b.sort
            //         });

            //     } else {
            //         this.$message({
            //             message: '暂无商品',
            //             type: 'warning'
            //         });
            //     }
            // });
        },
        //电话咨询
        callHandle() {
            this.$confirm('<div class="html-tag"><h4>请拨打客服电话</h4><p>4008-360-128</p></div>', {
                title: '',
                dangerouslyUseHTMLString: true,
                confirmButtonText: '我知道了',
                //cancelButtonText: '取消',
                showCancelButton: false,
                distinguishCancelAndClose: true,
                customClass: "Confirm-class"
                // type: 'warning'
            }).then(() => { }).catch(() => { });
        },
        //规格点击事件
        checkedHandle(type, item, index) {
            console.log(item, index);
            var specsValue1 = this.specsValue1;
            var specsValue2 = this.specsValue2;
            var specsValue3 = this.specsValue3;
            if (type == 1) {
                this.active1 = index;
                this.ids1 = item.skuId;
                this.specsValue1 = item.specsValue;
                //alert(ids1)

            } else if (type == 2) {

                this.active2 = index;
                this.ids2 = item.skuId;
                this.specsValue2 = item.specsValue;
                //alert(ids2)
            } else {
                this.active3 = index;
                this.ids3 = item.skuId;
                this.specsValue3 = item.specsValue;
            }

            if (this.ids1) {
                this.ids = this.ids1;
                this.skuName = this.specsValue1;
            }
            if (this.ids2) {

                this.ids = this.ids1 + ',' + this.ids2;
                this.skuName = this.specsValue1 + '' + this.specsValue2;
            }
            if (this.ids3) {
                this.ids = this.ids1 + ',' + this.ids2 + ',' + this.ids3;
                this.skuName = this.specsValue1 + '' + this.specsValue2 + '' + this.specsValue3;
            }

            this.getPriceData();
        },
        //立即下单
        placeHandle() {

            var arr = this.imgList.filter(item => item.flag != 20); //不等于20 代表不是视频
            var imgUrl = '';
            if (arr && arr.length > 0) {
                imgUrl = arr[0].imgUrl;
            }
            var obj = {
                productsPrice: this.productsPrice2 ? this.productsPrice2 : this.msg.productsPrice,
                num: this.num,
                imgUrl: imgUrl,
                ids: this.ids,
                brandName: this.msg.brandName,
                skuName: this.skuName,
                productsName: this.msg.productsName,
                id: this.msg.id
            }
            // this.msg.num = this.num;
            sessionStorage.setItem("item", JSON.stringify(obj));
            this.$router.push({ path: '/capital/place-order' });
        },
    },
};
</script>
<style>
#app .el-aside {
    overflow: auto;
    box-sizing: border-box;
    flex-shrink: 0;
    display: none !important;
}
</style>
<style lang="scss" scoped>
.wp {
    width: 1440px;
    max-width: 100%;
    margin: 0 auto;
}

.main {
    width: 80%;
    padding: 20px 15px 20px 15px !important;
    margin: 20px auto 0 !important;
}

.checked-list-box {
    width: 80%;
}

.resDataBox {
    margin-top: 18px;
}

::v-deep .bread .el-button {
    display: none !important;
}

::v-deep #app .header {
    cursor: not-allowed !important;
}

.commidityArea1 {

    color: #555555;
    font-size: 16px;
    line-height: 24px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 8;
    text-align: justify;
}

.top-wrap {
    // z-index: -1;
}
</style>
  